import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-cookies-center',
  templateUrl: './cookies-center.component.html',
  styleUrls: ['./cookies-center.component.scss'],
})
export class CookiesCenterComponent implements OnInit {
  cookieValue;
  cookiesCenter: boolean;
  isCookie: boolean;
  saveAnalyticsCookie: boolean;
  public isDesktopDevice: boolean;
  public isIframe: boolean;

  constructor(
    private cookieService: CookieService, 
    private deviceService: DeviceDetectorService
  ) {
    this.cookiesCenter = false;
    this.isCookie = false;
    this.saveAnalyticsCookie = false;
    this.isDesktopDevice = this.deviceService.isDesktop();
  }
  
  ngOnInit(): void {
    let name = window.location.pathname.split('/')[1] + '_cookiescenter';
    // console.log(name);
    if (this.checkCookie(name)) {
      this.isCookie = true;
    } else {
      this.isCookie = false;
    }

    // console.log(this.saveAnalyticsCookie);

    // Iframe detection (to show cookies disclaimer or not in iframe mode)
    this.isIframe = window.self !== window.top;
  }

  public openCookiesCenter() {
    this.cookiesCenter = true;
    this.isCookie = true;
  }

  private setCookie(cname, cvalue) {
    let d = new Date();
    d.setTime(d.getTime() + 3600 * 24 * 365 * 2 * 1000);
    let expires = d;

    this.cookieService.set(cname, cvalue, { expires });
  }

  private getCookie(cname) {
    const cookieValue = this.cookieService.get(cname);
    return cookieValue;
  }

  public saveCookies(permit: boolean) {
    let value;
    let name = window.location.pathname.split('/')[1] + '_cookiescenter';

    if (permit) {
      value = 'allow';
    } else {
      value = 'deny';
      this.deleteCookie('_ga');
      this.deleteCookie('_gid');
      this.deleteCookie('_gat');
      this.deleteCookie('collect');
    }
    this.setCookie(name, value);
    this.isCookie = true;
    this.cookiesCenter = false;
  }

  private checkCookie(name) {
    var token = this.getCookie(name);
    if (token != '') {
      return true;
    } else {
      return false;
    }
  }

  private deleteCookie(cname) {
    this.cookieService.delete(cname);
    this.isCookie = false;
  }

  public closeCookiesCenter() {
    this.cookiesCenter = false;
    this.isCookie = false;
  }
}
